<template>
  <component
    :is="tag"
    class="text-dark-electric-blue flex gap-2 p-2 items-center text-nowrap"
    :class="disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:bg-police-blue'"
    data-test="screen-sharing-menu-item"
    @click="onToggle"
  >
    <wui-icon
      :name="isSharingScreen ? 'screenShareOffM' : 'screenShareM'"
      small
      class="text-white"
    />
    <span class="text-white">{{ menuTitle }}</span>
  </component>
</template>
<script lang="ts" setup>
import { WuiIcon } from '@wui/common-library'
import { computed, toRefs } from 'vue'

import { useLocalization } from '@/shared/composables/localization'

import { useToggleScreenSharing } from '../lib'

const props = withDefaults(defineProps<{
  sessionId: string
  tag?: 'div' | 'li'
  disabled?: boolean
}>(), {
  tag: 'li',
  disabled: false,
})

const { disabled } = toRefs(props)
const { t } = useLocalization()
const { isSharingScreen, toggle } = useToggleScreenSharing()

const menuTitle = computed(() => {
  if (disabled.value) {
    return t('common.isOnHold')
  }

  return isSharingScreen.value ? t('calls.endScreenSharing') : t('calls.startScreenSharing')
})

const onToggle = () => {
  if (disabled.value) {
    return
  }

  void toggle()
}
</script>
